<template>
  <div>
    <div class="flex items-center justify-between mb-6">
      <h1 class="text-xl font-bold">{{ categoryName }}</h1>
    </div>

    <div v-if="loading" class="flex justify-center py-12">
      <app-loading />
    </div>

    <div v-else-if="subcategories.length === 0" class="bg-background-light rounded-xl p-6 text-center">
      <p class="text-text-secondary">No subcategories available in this category</p>
    </div>

    <div v-else class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      <subcategory-card
          v-for="subcategory in subcategories"
          :key="subcategory.id"
          :subcategory="subcategory"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import SubcategoryCard from '../components/product/SubcategoryCard.vue';
import { useDataStore } from '@/stores/dataStore.js'

export default {
  name: 'CategoryListing',
  components: {
    SubcategoryCard
  },
  props: {
    id: {
      type: [String, Number],
      required: false
    }
  },
  setup(props) {
    const route = useRoute();
    const loading = ref(true);
    const subcategories = ref([]);
    const category = ref(null);
    const allCategories = ref([]);
    const allSubcategories = ref([]);
    const dataStore = useDataStore();

    const categoryId = computed(() => {
      // Use prop id if available, otherwise get from route
      return props.id ? parseInt(props.id) : parseInt(route.params.id);
    });

    const categoryName = computed(() => {
      return category.value?.libelle || 'Category';
    });

    // Function to load data from API
    const loadData = async () => {
      try {
        loading.value = true;
        allCategories.value = dataStore.categories || [];
        allSubcategories.value = dataStore.subcategories|| [];

        updateCategory();
      } catch (error) {
        console.error('Failed to load category data:', error);
      } finally {
        loading.value = false;
      }
    };

    // Update category and subcategories based on ID
    const updateCategory = () => {
      if (!categoryId.value || !allCategories.value.length) {
        return;
      }

      // Find current category
      category.value = allCategories.value.find(cat => cat.id === categoryId.value) || null;

      // Filter subcategories
      subcategories.value = allSubcategories.value.filter(sub => {
        return Number(sub.categorie_id) === Number(categoryId.value);
      });

    };

    // Load data when component mounts
    onMounted(() => {
      loadData();
    });

    // Watch for ID changes from route or props
    watch(categoryId, () => {
      if (allCategories.value.length > 0) {
        updateCategory();
      }
    });

    return {
      loading,
      subcategories,
      category,
      categoryName
    };
  }
}
</script>